module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0150.jpg?v=ec938ee5";